import React from 'react';
import styles from './DiscourseTravelItem.module.scss';
import { useDiscourseContext } from '../../Services/DiscourseContext';
import useTranslation from '../../../../Hooks/useTranslation';
import {
	findDiscourseTravelAttachment,
	formatDiscourseTravelDistance,
} from './discourseTravel.helpers';

interface Props {
	onEdit: () => void;
}

const DiscourseTravelItem = ({ onEdit }: Props) => {
	const { discourseAttachments, removeAttachmentFromDiscourse } =
		useDiscourseContext();
	const { t } = useTranslation();

	const travel = findDiscourseTravelAttachment(discourseAttachments);

	if (!travel) {
		return null;
	}

	const handleRemove = (event: React.MouseEvent) => {
		event.stopPropagation();
		removeAttachmentFromDiscourse(travel.id);
	};

	return (
		<div className={styles.item}>
			<span className={styles.label}>{t('component.discourse.travel')}:</span>
			<button type='button' className={styles.value} onClick={onEdit}>
				{formatDiscourseTravelDistance(travel)}
			</button>
			<button
				type='button'
				className={styles.removeButton}
				onClick={handleRemove}
				aria-label={t('base.shared.remove')}>
				<img src='/dist/icons/xmark-solid-red.svg' alt='' />
			</button>
		</div>
	);
};

export default DiscourseTravelItem;
